import React, { useEffect, useState } from "react";
import { Link, makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  paddingLinks: {
    padding: "2% 10%",
    color:theme.palette.ePrimary?.base,
    [theme.breakpoints.up("md") && theme.breakpoints.down("sm")]: {
      padding:"1% 10% "
     },
  },
}));

export default function CardLink({ item, k }) {
  let classes = useStyle();
  const [openNewTab,setNotOpen]=useState(true)
  useEffect(()=>{
      if(item?._source?.ContentValue.includes("baseUrl")){
        setNotOpen(false)
      }else{
          setNotOpen(true)
      }
  },[item?._source?.ContentValue])
  return (
    <div className={classes.paddingLinks}>
      <Link
        variant="body2"
        href={item?._source?.ContentValue.replace(
          "baseUrl",
          ""
        )}
        underline="always"
        target={openNewTab && "_blank"}
      >
        {item?._source?.ContentTitle}
      </Link>
    </div>
  );
}
